import { FC, memo } from 'react'
import { AiAssistantWindowPanel } from 'features/aiAssistant/components/aiAssistantWindowPanel/aiAssistantWindowPanel'

export const AppAiAssistantWindow: FC = memo(() => {
  return (
    <div className="h-full w-[720px] crew-bg-default border crew-border-gray drop-shadow-md crew-shadow-gray rounded-lg">
      <AiAssistantWindowPanel />
    </div>
  )
})
